import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";
import { youtubeUrlSchema } from "../zod/youtubeUrlSchema.js";

export const videoTextBlockSchema = z.object({
	youtubeUrl: youtubeUrlSchema,
	html: nonEmptyString,
	reversed: z.boolean(),
});
